<!-- Promotion modal-->
<div id="promotionModal" *ngIf="isPromo">
  <div class="modal-header pd-xy-15 ">
    <h6 class="modal-title" id="modal-basic-title">{{authoringContentData?.changeService?.promotionHeader}}</h6>
    <button type="button" class="close def-selected" aria-label="Close" (click)="onClickPromoClose($event)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="promoContent">{{authoringContentData?.changeService?.promotionSubHeader}}</div>
    <div class="body_bold">{{authoringContentData?.changeService?.ifYouRemove}}</div>
    <div class="removingServiceStyle">{{removingService}}</div>
    <div class="body_bold bottomSpace">{{authoringContentData?.changeService?.followingPromotions}}</div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="row">
        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8 body_bold">{{authoringContentData?.changeService?.tableColumn1}}</div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 body_bold">{{authoringContentData?.changeService?.tableColumn2}}</div>
      </div>
    </div>
    <div class='promo_table'>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 rowDivider">
        <div class="row rowContentSpace" *ngFor="let desc of promotionDesc; let i=index">
          <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">{{desc}}</div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 breakWord">{{lineID}}</div>
      </div>
      </div>
    </div>    
  </div> 
  <div class="modal-footer">
    <div class="row">
      <div>
        <button mat-stroked-button (click)="onClickPromoClose($event)" type="button"
        class="btn secondary_btn only-bdr-btn">{{authoringContentData?.changeService?.cancelTxt}}</button>
      </div>
      <div>
        <button mat-stroked-button (click)="acceptAndContinue()" type="button"
        class="btn primary_btn order-sm-1">{{authoringContentData?.changeService?.acceptBtn}}</button>        
      </div>
    </div>
    <p class="btn_bottom_txt">{{authoringContentData?.changeService?.acceptBottomTxt}}</p>    
  </div> 
</div>